import { NavLink, Outlet } from "react-router-dom";
import { Archive } from "lucide-react";
import { GroupProvider, useGroup } from "@/lib/GroupContext";
import { SiteHeader, SiteFooter } from "@/components/Brand";
import { EvidenceLocker } from "@/components/EvidenceLocker";

const navCls = ({ isActive }) => `nav-link ${isActive ? "active" : ""}`;

function Nav() {
  const { state, setLockerOpen } = useGroup();
  return (
    <div className="site-nav">
      <nav className="site-container flex items-center" aria-label="Case navigation">
        <NavLink end to="/" className={navCls} data-testid="nav-hub">Suspect interviews</NavLink>
        <NavLink to="/briefing" className={navCls} data-testid="nav-briefing">Briefing</NavLink>
        <NavLink to="/charge" className={navCls} data-testid="nav-accusation">Charge decision</NavLink>
        <button className="btn-onblue ml-auto" onClick={() => setLockerOpen(true)} data-testid="open-evidence-locker-button">
          <Archive size={18} /> Submit evidence reference
          <span className="evidence-count" data-testid="header-clue-count">{state ? state.clues_unlocked : 0}/4</span>
        </button>
      </nav>
    </div>
  );
}

export function Layout() {
  return (
    <GroupProvider>
      <div className="relative z-10 min-h-screen flex flex-col">
        <SiteHeader nav={<Nav />} />
        <main className="site-container w-full flex-1 pb-24">
          <Outlet />
        </main>
        <SiteFooter />
        <EvidenceLocker />
      </div>
    </GroupProvider>
  );
}
